import { render } from "./fire-register-header.vue?vue&type=template&id=63c9aac9"
import script from "./fire-register-header.vue?vue&type=script&lang=js"
export * from "./fire-register-header.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__